import { render, staticRenderFns } from "./gk-table.vue?vue&type=template&id=f13d4f1c"
import script from "./gk-table.vue?vue&type=script&lang=js"
export * from "./gk-table.vue?vue&type=script&lang=js"
import style0 from "./gk-table.vue?vue&type=style&index=0&id=f13d4f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports